<template>
    <div v-bind="$attrs">
        <apex-charts type="area" :height="height" :options="chartOptions" :series="series"></apex-charts>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { colors } from '@/Composables/ChartColors';
import { formatIntegerPrice } from '@/Mixins/Formatting';

export default {
    props: {
        options: {
            type: Object,
            default: function () {
                return {};
            },
        },

        height: {
            type: String,
            default: '100%',
        },

        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        alignTitleLeft: {
            type: Boolean,
            default: false,
        },

        curve: {
            type: String,
            default: 'smooth',
        },

        series: {
            type: Array,
            required: true,
        },

        isPriceChart: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        chartOptions() {
            return {
                noData: {
                    text: i18n.t('charts.noData'),
                    align: 'center',
                    verticalAlign: 'middle',
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        color: undefined,
                        fontSize: '14px',
                        fontFamily: undefined,
                    },
                },
                chart: {
                    toolbar: {
                        show: false,
                    },
                },

                yaxis: {
                    labels: {
                        // Will affect the values on the left side of the chart, and also the values on each label's tooltip if tooltip.y.formatter is not used
                        formatter: (val) => {
                            return this.isPriceChart ? formatIntegerPrice(val) : val;
                        },
                    },
                },

                dataLabels: {
                    formatter: (val) => {
                        return this.isPriceChart ? formatIntegerPrice(val) : val;
                    },
                },

                tooltip: {
                    y: {
                        // If no formatter is set here, will use yaxis.labels.formatter
                        formatter: (val) => {
                            return this.isPriceChart ? formatIntegerPrice(val) : val;
                        },
                        title: {
                            // Hide the series name as we won't need it.
                            // formatter: (seriesName) => {
                            formatter: () => {
                                return '';
                            },
                        },
                    },
                },

                title: {
                    text: this.title,
                    align: this.alignTitleLeft ? 'left' : 'center',
                    style: {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        fontFamily: 'Spartan',
                        color: '#006DB6',
                        //color: '#154579',
                    },
                },
                subtitle: {
                    text: this.subtitle,
                    align: this.alignTitleLeft ? 'left' : 'center',
                    style: {
                        fontSize: '11px',
                        fontFamily: 'Spartan',
                        color: '#1e1e1e',
                    },
                },
                /*responsive: [
                    {
                    breakpoint: 1600
                    }
                ],*/
                colors: colors,

                stroke: {
                    curve: this.curve,
                },

                ...this.options,
            };
        },
    },
};
</script>

<style></style>
